// extracted by mini-css-extract-plugin
export default {"updateuser_wrap":"updateuserform_updateuser_wrap__r9Mui","updateuser_form":"updateuserform_updateuser_form__LNza3"};